<div
  *ngIf="false && !env.production"
  class="bg-primary text-primary-foreground fixed bottom-20 hidden rounded-md py-1 px-3 align-middle text-sm font-medium ltr:right-5 rtl:left-5 sm:block">
  <span class="hidden sm:block md:hidden">sm test</span>
  <span class="hidden md:block lg:hidden">md test</span>
  <span class="hidden lg:block xl:hidden">lg test</span>
  <span class="hidden xl:block 2xl:hidden">xl test</span>
  <span class="hidden 2xl:block">2xl test</span>
</div>
